"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEEddystoneTLMBuilder = exports.BLEEddystoneTLM = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BLEEddystone_1 = require("./BLEEddystone");
const BLEService_1 = require("./BLEService");
const BLEUUID_1 = require("./BLEUUID");
let BLEEddystoneTLM = class BLEEddystoneTLM extends BLEEddystone_1.BLEEddystone {
    get encrypted() {
        return this.version === 0x01;
    }
    isValid() {
        return super.isValid() && this.frame === 0x20;
    }
    computeUID() {
        return this.address ? this.address.toString() : this.uid;
    }
    parseServiceData(uuid, serviceData) {
        super.parseServiceData(uuid, serviceData);
        if (uuid === undefined && serviceData === undefined) {
            return this;
        }
        if (!this.service) {
            return this;
        }
        if (this.frame !== 0x20) {
            return this; // Do not attempt to parse
        }
        const view = new DataView(serviceData.buffer, 0);
        this.version = view.getUint8(1);
        if (this.version === 0x01) {
            // Encrypted
        }
        else {
            // Unencrypted
            this.voltage = view.getUint16(2);
            const temperatureRaw = view.getInt16(4);
            if (temperatureRaw !== 0x8000) {
                const temperatureSigned = (temperatureRaw & 0x8000) > 0 ? -1 : 1;
                const temperature = (temperatureSigned * temperatureRaw) / Math.pow(2, 8);
                this.temperature = new core_1.Temperature(Math.round(temperature * 100) / 100, core_1.TemperatureUnit.CELCIUS);
            }
            this.advertiseCount = view.getUint32(6);
            this.uptime = new core_1.UnitValue(view.getUint32(10) * 0.1, core_1.TimeUnit.SECOND);
        }
        if (this.uid === undefined) {
            this.uid = this.computeUID();
        }
        return this;
    }
};
exports.BLEEddystoneTLM = BLEEddystoneTLM;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEEddystoneTLM.prototype, "version", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEEddystoneTLM.prototype, "voltage", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", core_1.Temperature)
], BLEEddystoneTLM.prototype, "temperature", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEEddystoneTLM.prototype, "advertiseCount", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", core_1.UnitValue)
], BLEEddystoneTLM.prototype, "uptime", void 0);
exports.BLEEddystoneTLM = BLEEddystoneTLM = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], BLEEddystoneTLM);
/**
 * BLE Eddystone TLM builder
 */
class BLEEddystoneTLMBuilder extends BLEBeaconObject_1.BLEBeaconBuilder {
    constructor() {
        super();
        this.beacon = new BLEEddystoneTLM();
        this.beacon.frame = 0x20;
        this.beacon.version = 0x00;
    }
    static create() {
        return new BLEEddystoneTLMBuilder();
    }
    static fromBeacon(beacon) {
        const builder = new BLEEddystoneTLMBuilder();
        builder.beacon = beacon;
        return builder;
    }
    calibratedRSSI(rssi) {
        this.beacon.calibratedRSSI = rssi;
        return this;
    }
    voltage(voltage) {
        this.beacon.voltage = voltage;
        return this;
    }
    temperature(temperature, unit = core_1.TemperatureUnit.CELCIUS) {
        this.beacon.temperature = new core_1.Temperature(temperature, unit);
        return this;
    }
    uptime(time, unit = core_1.TimeUnit.SECOND) {
        this.beacon.uptime = new core_1.UnitValue(time, unit);
        return this;
    }
    advertiseCount(count) {
        this.beacon.advertiseCount = count;
        return this;
    }
    build() {
        return new Promise((resolve) => {
            // Eddystone Service
            const serviceData = new DataView(new ArrayBuffer(14));
            serviceData.setUint8(0, 0x20); // Eddystone-TLM frame
            serviceData.setInt8(1, 0x00); // Version
            serviceData.setUint16(2, this.beacon.voltage);
            if (this.beacon.temperature) {
                serviceData.setInt16(4, Math.round(this.beacon.temperature.value * 256.0));
            }
            else {
                serviceData.setInt16(4, 0x8000);
            }
            serviceData.setUint32(6, this.beacon.advertiseCount);
            if (this.beacon.uptime) {
                serviceData.setUint32(10, this.beacon.uptime.to(core_1.TimeUnit.SECOND).valueOf() / 0.1);
            }
            this.beacon.addService(new BLEService_1.BLEService(BLEUUID_1.BLEUUID.fromString('FEAA'), new Uint8Array(serviceData.buffer)));
            this.beacon.uid = this.beacon.computeUID();
            resolve(this.beacon);
        });
    }
}
exports.BLEEddystoneTLMBuilder = BLEEddystoneTLMBuilder;
//# sourceMappingURL=BLEEddystoneTLM.js.map